module.exports = __webpack_public_path__ + "static/media/nav-link-arrow-icon.8a7d8fa0.svg";